module.exports = __webpack_public_path__ + "assets/b34.png";


//////////////////
// WEBPACK FOOTER
// ./images/boomerang-frames/b34.png
// module id = 621
// module chunks = 0